import { AnyAction } from 'redux';
import { EmploymentCompensation, EmploymentCompensationActions, EmploymentCompensationState } from './employment-compensation-models';

const InitialState: EmploymentCompensationState = {
	employmentCompensation: [],
	employmentCompensationLoaded: false,
};



export const employmentCompensationReducer = (state = InitialState, action: AnyAction): EmploymentCompensationState => {

	switch (action.type) {
		case EmploymentCompensationActions.SET_EMPLOYMENT_COMPENSATION:
			return {
				...state,
				employmentCompensation: action.payload,
				employmentCompensationLoaded: true,
			};
		case EmploymentCompensationActions.CLEAR_EMPLOYMENT_COMPENSATION:
			return {
				...state,
				employmentCompensation: [],
				employmentCompensationLoaded: false,
			};

		default: return state;
	}
};


export const setEmploymentCompensation = (employmentCompensation: EmploymentCompensation[]) => {
	return {
		type: EmploymentCompensationActions.SET_EMPLOYMENT_COMPENSATION,
		payload: employmentCompensation,
	};
};

export const clearEmploymentCompensation = () => {
	return {
		type: EmploymentCompensationActions.CLEAR_EMPLOYMENT_COMPENSATION,
	};
};
